import Cookies from "universal-cookie";
import "./AdminDashboard.css";

const AdminDashboard = () => {
    const cookies = new Cookies();

    return (
        <h2 className="welcomeText">
            Welcome back{" "}
            {cookies.get("twitch_user")
                ? cookies.get("twitch_user").toUpperCase()
                : "NO USER"}
        </h2>
    );
};

export default AdminDashboard;
